import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/AppShell";

export default function PaymentResult({ success }) {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState(success ? "checking" : "cancelled");

  useEffect(() => {
    if (!success) return;
    const id = params.get("session_id");
    let n = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${id}`);
        if (data.payment_status === "paid") { await refresh(); return setState(data.trial ? "trial" : "paid"); }
        if (data.status === "expired") return setState("failed");
      } catch (e) { console.warn("Payment status check failed, retrying", e?.response?.status ?? e?.message); }
      if (++n < 15) setTimeout(tick, 2000); else setState("timeout");
    };
    tick();
  }, [success, params, refresh]);

  const copy = {
    checking: ["Confirming your payment…", "This usually takes a few seconds."],
    paid: ["Welcome to CAMRYN Plus.", "Unlimited Companion, 30-day trends, patterns and weekly reflections are now open to you."],
    trial: ["Your 7-day Plus trial has started.", "Everything in Plus is open to you. You won't be charged until day 8, and you can cancel any time from Me."],
    failed: ["That payment didn't go through.", "No charge was made. You can try again any time."],
    timeout: ["Still confirming.", "We'll unlock Plus as soon as Stripe confirms. Check back in a minute."],
    cancelled: ["Checkout cancelled.", "No charge was made. Your free plan is unchanged."],
  }[state];

  return (
    <div className="grain min-h-screen grid place-items-center px-6">
      <div className="relative z-10 max-w-md text-center" data-testid={`payment-result-${state}`}>
        <Logo />
        <h1 className="font-display text-3xl sm:text-4xl mt-10 tracking-tight">{copy[0]}</h1>
        <p className="text-stone-600 mt-3">{copy[1]}</p>
        {state === "checking" ? <div className="mx-auto mt-8 h-8 w-8 rounded-full border-2 border-[#C86D51] border-t-transparent animate-spin" /> :
          <Link to={["paid", "trial"].includes(state) ? "/today" : "/pricing"} data-testid="payment-result-continue-btn" className="btn-ink inline-flex mt-8 px-7 py-3 rounded-full font-semibold">{["paid", "trial"].includes(state) ? "Go to Today" : "Back to plans"}</Link>}
      </div>
    </div>
  );
}
